import { authAPI, fetchAPI } from '@/shared/lib/api/client';

import { User } from '../model/types';

export interface DepositResponse {
  success: boolean;
  tx_hash: string;
  amount: number;
  new_balance: number;
}

export interface TonDepositIntentResponse {
  id: string;
  destination_address: string;
  memo: string;
  amount: number;
  amount_nano: number;
  payment_uri: string;
  status: string;
  expires_at: string;
  tx_hash: string | null;
  actual_amount: number | null;
}

export interface StarsInvoiceResponse {
  invoice_link: string;
  payload: string;
  amount: number;
}

export const userApi = {
  async devLogin(): Promise<{ access_token: string; refresh_token: string }> {
    const { data } = await authAPI.post('/auth/dev');
    return data;
  },

  async telegramLogin(initData: string, referralCode?: string): Promise<{ access_token: string; refresh_token: string }> {
    const { data } = await authAPI.post('/auth/telegram', { init_data: initData, referral_code: referralCode ?? null });
    return data;
  },

  async fetchUser(): Promise<User> {
    const { data } = await fetchAPI.get<User>('/user/me');
    return data;
  },

  async updateProfile(updates: Partial<User>): Promise<User> {
    const { data } = await fetchAPI.patch<User>('/user/profile', updates);
    return data;
  },

  async createTonDepositIntent(amount: number): Promise<TonDepositIntentResponse> {
    const { data } = await fetchAPI.post<TonDepositIntentResponse>('/deposit/ton/intent', {
      amount,
    });
    return data;
  },

  async confirmTonDepositIntent(intentId: string, boc?: string): Promise<DepositResponse> {
    const { data } = await fetchAPI.post<DepositResponse>(
      `/deposit/ton/intent/${intentId}/confirm`,
      { boc: boc ?? null },
      { timeout: 60000 },
    );
    return data;
  },

  async createStarsInvoice(amount: number): Promise<StarsInvoiceResponse> {
    const { data } = await fetchAPI.post<StarsInvoiceResponse>('/deposit/stars/invoice', {
      amount,
    });
    return data;
  },

  async getClientSeed(): Promise<string> {
    const { data } = await fetchAPI.get<{ client_seed: string }>('/user/me/client-seed');
    return data.client_seed;
  },

  async updateClientSeed(seed: string): Promise<string> {
    const { data } = await fetchAPI.patch<{ client_seed: string }>('/user/me/client-seed', { client_seed: seed });
    return data.client_seed;
  },

  async updateLanguage(language: string): Promise<string> {
    const { data } = await fetchAPI.patch<{ language: string }>('/user/me/language', { language });
    return data.language;
  },

};
